export default __webpack_public_path__ + "static/media/LG.42597969.svg";